import React from 'react';
import { Box, Typography } from '@mui/material';
import emblemOfIndia from '../../assets/images/layout/Emblem_of_India.png';
import sealOfMaharashtra from '../../assets/images/layout/Seal_of_Maharashtra.png';

function Header() {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        padding: { xs: '8px 16px', md: '10px 20px' },
        backgroundColor: '#ffffff',
        flexWrap: 'wrap',
      }}
    >
      <Box
        component="img"
        src={emblemOfIndia}
        alt="Emblem of India"
        sx={{
          height: { xs: '30px', md: '50px' },
          marginRight: '8px',
          width: { xs: '30px', md: '50px' }
        }}
      />

      <Typography
        variant="h5"
        sx={{
          fontWeight: 'bold',
          flexGrow: 1,
          fontSize: { xs: '1rem', sm: '1.4rem', md: '1.8rem' },
          color: '#333333',
          marginRight: 'auto',
        }}
      >
        General Administration Department
      </Typography>

      <Box
        component="img"
        src={sealOfMaharashtra}
        alt="Seal of Maharashtra"
        sx={{
          height: { xs: '30px', md: '50px' },
          width: { xs: '30px', md: '50px' },
        }}
      />
    </Box>
  );
}

export default Header;
